import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import _ from "underscore";
import modals from 'webmodals/modals'

export default class SalesRepGoalsPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Sales Goals";
    $ctrl.repId = options.repId || "";
    $ctrl.vendorId = options.vendorId || "";
    $ctrl.categoryId = options.categoryId || "";
  }
  getMonthName(month) {
    const $ctrl = this;
    return moment(month, 'M').format('MMM');
  }
  dismiss() {
    const $ctrl = this;
    $ctrl.$dismiss();
  }
  delete() {
    const $ctrl = this;
    return modals.confirm("Are you sure?", "Delete Goal").result.then(function () {
      $ctrl.bus.send('DeleteRepMonthlyGoals.json?', {
        RepId: $ctrl.repId,
        VendorId: $ctrl.vendorId,
        CategoryId: $ctrl.categoryId
      }).then(function (response) {
        $ctrl.$close();
      });
    });
  }
  save() {
    const $ctrl = this;
    if ($ctrl.repId) {
      $ctrl.bus.send('DeleteRepMonthlyGoals.json?', {
        RepId: $ctrl.repId,
        VendorId: $ctrl.vendorId,
        VendorIdIsEmpty: $ctrl.vendorId == "" ? true : false,
        CategoryId: $ctrl.categoryId
      }).then(function (response) {
        $ctrl.goals.forEach(function (goal) {
          $ctrl.bus.send('CreateRepMonthlyGoal.json', goal);
        });
        $ctrl.$close();
      });
    } else {
      $ctrl.goals.forEach(function (goal) {
        goal.repId = $ctrl.salesRep.id;
        goal.vendorId = $ctrl.vendorId;
        goal.categoryId = $ctrl.categoryId;
        $ctrl.bus.send('CreateRepMonthlyGoal.json', goal);
      });
      $ctrl.$close();
    }
  }
  $onInit() {
    const $ctrl = this;
    if ($ctrl.vendorId) {
      $ctrl.bus.send('QueryVendors.json?Id=' + $ctrl.vendorId).then(function (res) {
        if (res.data.results) $ctrl.vendor = res.data.results[0];
      });
    }
    if ($ctrl.categoryId) {
      $ctrl.bus.send('QueryProductCategories.json?Id=' + $ctrl.categoryId).then(function (res) {
        if (res.data.results) $ctrl.category = res.data.results[0];
      });
    }
    if ($ctrl.repId) {
      $ctrl.bus.send('QuerySalesReps.json?Id=' + $ctrl.repId).then(function (res) {
        if (res.data.results) $ctrl.salesRep = res.data.results[0];
      });
      var url = 'QueryRepMonthlyGoals.json?repId=' + $ctrl.repId + '&orderBy=RepId,VendorId,StartDate';
      if ($ctrl.vendorId) {
        url = url + '&vendorId=' + $ctrl.vendorId;
      } else {
        url = url + '&vendorIdIsEmpty=1';
      }
      $ctrl.bus.send(url).then(function (res) {
        console.info("res", res);
        if (res.data.total > 0) {
          $ctrl.goals = res.data.results;
        } else {
          $ctrl.goals = [];
          for (var i = 1; i <= 12; i++) {
            $ctrl.goals.push({
              repId: $ctrl.repId,
              month: i,
              startDate: moment(moment().year() + '-01-01T12:00:00.000').add(i - 1, 'months'),
              goal: 0,
              invoiceGoal: 0,
              actualBooked: 0,
              actualInvoiced: 0,
              vendorId: $ctrl.vendorId,
              categoryId: $ctrl.categoryId
            });
          }
        }
        
      });
      console.info("$ctrl.goals", $ctrl.goals);
    } else {
      $ctrl.bus.send('QuerySalesRepList.json?Active=1&OrderBy=Name').then(function (res) {
        $ctrl.reps = res.data.results;
      });
      $ctrl.goals = [];
      for (var i = 1; i <= 12; i++) {
        $ctrl.goals.push({
          repId: "",
          month: i,
          startDate: moment(moment().year() + '-01-01T12:00:00.000').add(i - 1, 'months'),
          goal: 0,
          invoiceGoal: 0,
          actualBooked: 0,
          actualInvoiced: 0,
          vendorId: $ctrl.vendorId,
          categoryId: $ctrl.categoryId
        });
      }
      console.info("$ctrl.goals", $ctrl.goals);
    }
  }
}
